module.exports = __webpack_public_path__ + "static/media/8780.7c516d42.png";